import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone, Instagram, Facebook } from "lucide-react";

const empty = { name: "", email: "", subject: "", message: "" };

const Contact = () => {
  const [form, setForm] = useState(empty);
  const [submitting, setSubmitting] = useState(false);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Name, email and message are required");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/contacts", form);
      toast.success("Message sent. Talk soon.");
      setForm(empty);
    } catch {
      toast.error("Could not send your message");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page" className="min-h-screen">
      <section className="pt-20 pb-12 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <p className="eyebrow fade-up">Get in touch</p>
          <h1 className="font-heading text-6xl md:text-8xl uppercase leading-[0.9] mt-5 fade-up-1" data-testid="contact-title">
            Say Hi
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-neutral-300 fade-up-2">
            For bookings, press, or just to say what's up.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1 space-y-8">
            <div>
              <p className="eyebrow">Booking</p>
              <a href="mailto:kreisws01@gmail.com" className="block font-heading text-2xl mt-2 hover:underline break-all" data-testid="contact-email">
                <Mail size={16} className="inline mr-3 -mt-1"/> kreisws01@gmail.com
              </a>
            </div>
            <div>
              <p className="eyebrow">Phone</p>
              <a href="tel:+13102000803" className="block font-heading text-2xl mt-2 hover:underline" data-testid="contact-phone">
                <Phone size={16} className="inline mr-3 -mt-1"/> 310.200.0803
              </a>
            </div>
            <div>
              <p className="eyebrow">Follow</p>
              <div className="flex gap-4 mt-3">
                <a href="https://instagram.com/iloveretrofitmusic" target="_blank" rel="noreferrer" className="text-white hover:opacity-60 transition" data-testid="contact-instagram"><Instagram size={22}/></a>
                <a href="https://www.facebook.com/retrofitmusic" target="_blank" rel="noreferrer" className="text-white hover:opacity-60 transition" data-testid="contact-facebook"><Facebook size={22}/></a>
              </div>
            </div>
            <div>
              <p className="eyebrow">Based in</p>
              <p className="font-heading text-2xl mt-2">The Southbay, California</p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <form onSubmit={submit} className="space-y-10" data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-10">
                <div>
                  <label className="label-retro">Name *</label>
                  <input value={form.name} onChange={onChange("name")} className="field" required data-testid="ct-name" />
                </div>
                <div>
                  <label className="label-retro">Email *</label>
                  <input type="email" value={form.email} onChange={onChange("email")} className="field" required data-testid="ct-email" />
                </div>
              </div>
              <div>
                <label className="label-retro">Subject</label>
                <input value={form.subject} onChange={onChange("subject")} className="field" data-testid="ct-subject" />
              </div>
              <div>
                <label className="label-retro">Message *</label>
                <textarea value={form.message} onChange={onChange("message")} className="field-area" required data-testid="ct-message" />
              </div>
              <div className="border-t border-white/10 pt-6 flex items-center justify-end">
                <button disabled={submitting} type="submit" className="btn-retro-solid disabled:opacity-50" data-testid="ct-submit">
                  {submitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
